import Vue from "vue";
import VueRouter from "vue-router";
import { jwtDecode } from "jwt-decode";
import { getRolesForPath } from "@/plugins/routePermissions";
// import { sidebarMenu } from "@/components/sidebar/SidebarMenu";
import axios from "axios";

Vue.use(VueRouter);

const routeModules = require.context("./groups", true, /routes\.js$/);
const routes = [];

routeModules.keys().forEach((fileName) => {
  const routeModule = routeModules(fileName).default;
  routes.push(...routeModule);
});

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

let sidebarMenu = [];

async function fetchMenuOnce() {
  if (sidebarMenu.length === 0) {
    try {
      const res = await axios.get("/v1/menus");
      sidebarMenu = res.data;
    } catch (err) {
      console.error("Gagal ambil menu:", err);
    }
  }
}

router.beforeEach(async (to, from, next) => {
  await fetchMenuOnce();
  // 1. Handle token dari query parameter (untuk deep linking)
  const token = to.query.token;
  const username = to.query.name;
  let userData = localStorage.getItem("userData");
  let userLevel = null;

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > now) {
        const newUserData = {
          nama: username || decodedToken.name || "User",
          token: token,
          role: decodedToken.role,
        };

        localStorage.setItem("userData", JSON.stringify(newUserData));
        userData = JSON.stringify(newUserData);
        userLevel = decodedToken.role;

        const lastRoute = localStorage.getItem("lastRoute") || "/dashboard";
        localStorage.removeItem("lastRoute");
        return next(lastRoute);
      }
    } catch (err) {
      console.error("Invalid token from query:", err);
      localStorage.removeItem("userData");
      return next("/login");
    }
  }

  // 2. Cek user yang sudah login
  if (userData) {
    try {
      const userAccess = JSON.parse(userData);
      const decodedToken = jwtDecode(userAccess.token);
      const now = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > now) {
        userLevel = decodedToken.role || userAccess.role;
      } else {
        localStorage.removeItem("userData");
        return next("/login");
      }
    } catch (err) {
      console.error("Invalid token:", err);
      localStorage.removeItem("userData");
      return next("/login");
    }
  }

  // 3. Konversi userLevel ke array untuk konsistensi
  const userRoles = userLevel
    ? Array.isArray(userLevel)
      ? userLevel
      : [userLevel]
    : [];

  // 4. Handle public routes (tidak perlu login)
  if (to.matched.some((record) => record.meta.public)) {
    return next();
  }

  // 5. Redirect ke login jika belum autentikasi
  if (!userData && to.path !== "/login") {
    localStorage.setItem("lastRoute", to.fullPath);
    return next("/login");
  }

  // 6. Redirect dari login jika sudah autentikasi
  if (userData && to.path === "/login") {
    const lastRoute = localStorage.getItem("lastRoute") || "/dashboard";
    localStorage.removeItem("lastRoute");
    return next(lastRoute);
  }

  // 7. Dapatkan requiredLevel dari meta route atau sidebarMenu
  const requiredLevel =
    to.meta.requiredLevel || getRolesForPath(to.path, sidebarMenu);

  // 8. Check authorization
  if (requiredLevel) {
    const allowedRoles = Array.isArray(requiredLevel)
      ? requiredLevel
      : [requiredLevel];

    const hasAccess = allowedRoles.some((role) => userRoles.includes(role));

    if (!hasAccess) {
      return next("/forbidden");
    }
  }

  // 9. Set title dari route atau sidebar menu
  const setPageTitle = (path) => {
    const findTitle = (menus) => {
      for (const menu of menus) {
        if (menu.path === path) return menu.title;
        if (menu.children) {
          const childTitle = findTitle(menu.children);
          if (childTitle) return childTitle;
        }
      }
      return null;
    };

    const title = to.meta.title || findTitle(sidebarMenu) || "App";
    document.title = `Bank Soal - ${title}`;
  };

  setPageTitle(to.path);

  // 10. Jika semua pengecekan lolos
  next();
});

export default router;
